import React from "react";
import { useTranslation } from 'react-i18next';

import Logo from "components/svg/Logo";
import Button from "elements/Button";
import FlipReset from "../../containers/FlipMatchReset/FlipMatchReset";
import FlipCardSelect from "../../containers/FlipMatchSelect/FlipMatchSelect";

const Header = () => {
    const [ t ] = useTranslation();

    return (
        <div className="header py-2 shadow">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-auto d-flex align-items-center">
                        <Button href="/" type="btn-link" className="p-0"><Logo height={24} width={32} /></Button>
                        <span className="separator-h mx-2" />
                        <span className="text-primary"><b>{t("logo_strapline")}</b></span>
                    </div>
                    <div className="col-md-auto d-flex align-items-center justify-content-between ml-auto mt-2 mt-md-0">
                        <FlipCardSelect className="form-control form-control-sm mr-2" selected="test" emptyOption={t("choose_card_collection")}/>
                        <FlipReset className="btn btn-sm btn-primary" confirm={t("reset_confirm")}>{t("reset")}</FlipReset>
                    </div>
                </div>
            </div>
        </div>
    );
};

Header.propTypes = {};
Header.defaultProps = {};

export default Header;